import { render } from "./HorseLocationDetails.vue?vue&type=template&id=6255f1c8&ts=true"
import script from "./HorseLocationDetails.vue?vue&type=script&lang=ts"
export * from "./HorseLocationDetails.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/trend/MANARATFOUNDATION/KRC-FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__